import { render } from "./MedicarePartC.vue?vue&type=template&id=ca30ab8a&scoped=true"
import script from "./MedicarePartC.vue?vue&type=script&lang=js"
export * from "./MedicarePartC.vue?vue&type=script&lang=js"

import "./MedicarePartC.vue?vue&type=style&index=0&id=ca30ab8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca30ab8a"]])

export default __exports__